import React from 'react';

import { Link as RouterLink } from 'react-router-dom';
import Link from '@mui/material/Link';

import IconButton from '@mui/material/IconButton';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';


type Props = {
    mode : 'link' | 'button';
    label : string | null;
    structure: 'client' | 'facture' | 'litige' | 'article' | 'commande' | 'bonlivraison' | 'recent';
    cle : string,
    environment?: 'PROD' | 'RECETTE' | 'DEV' | null;
    /** En mode 'button', position de l'icône par rapport au label. Défaut : 'after'. */
    iconPosition?: 'before' | 'after';
};

const baseURL = {
    "PROD": "https://gesweb.foussier.fr/",
    "RECETTE" : "https://gesweb-preprod.foussier.fr/",
    "DEV" : "https://gesweb-preprod.foussier.fr/"
}

// desktopId par défaut historique (litige, facture, etc.) : "27".
// vwsKey : clé de la vue GesWeb à ouvrir, propre à certains écrans (absent = non transmis).
const DEFAULT_DESKTOP_ID = "27";

const structures = [
    { nom: "client", cle: "CLI", id: "13" },
    { nom: "facture", cle: "FAC", id: "780" },
    { nom: "litige", cle: "LITFAC", id: "785" },
    { nom: "article", cle: "PRO", id: "531" },
    { nom: "commande", cle: "ENT", id: "138", desktopId: "FOU6", vwsKey: "663" },
    { nom: "bonlivraison", cle: "LIV", id: "605", desktopId: "FOU6", ctxNavNotSet: true },
    { nom: "recent", cle: "RECENT", id: "2806", desktopId: "FOU6", vwsKey: "106022" }
];


export default function GeswebLink({ mode, label, structure, cle, environment, iconPosition = 'after' } : Props) {

    let selectedENV = environment;
    if(!selectedENV)
    {
        selectedENV = 'DEV';
        const hostname = window.location.hostname;
        if (!hostname.includes("localhost") && !hostname.includes("dev") && !hostname.includes("recette"))
        {
            selectedENV = 'PROD';
        } else if (hostname.includes("recette")) {
            selectedENV = 'RECETTE';
        }
    }

    const selectedStructure = structures.find(x => x.nom === structure) as
        | { nom: string; cle: string; id: string; desktopId?: string; vwsKey?: string; ctxNavNotSet?: boolean }
        | undefined;

    // On n'ajoute vwsKey / ctxNavNotSet que lorsqu'ils sont définis pour rester
    // rétro-compatible avec les structures historiques (litige, facture...) qui ne
    // les transmettent pas.
    const moduleParameters: Record<string, unknown> = {
        "argsAreSet": false,
        "contextNav": [{
            "des": "DES",
            "key": selectedStructure?.cle,
            "vws": null
        }],
        "type": "Form",
        "structId": selectedStructure?.id,
        "dataId": cle
    };

    if (selectedStructure?.ctxNavNotSet) {
        moduleParameters["ctxNavNotSet"] = true;
    }

    if (selectedStructure?.vwsKey) {
        moduleParameters["vwsKey"] = selectedStructure.vwsKey;
    }

    const desktopId = selectedStructure?.desktopId || DEFAULT_DESKTOP_ID;

    let url = baseURL[selectedENV!] + `openExternal?entityId=defaut&desktopId=${desktopId}&moduleParameters=`;
    url += JSON.stringify(moduleParameters);

  const iconButton = (
    <IconButton
        href={url}
        target="_blank"
        sx={{ p: 0 }}
    >
        <OpenInNewIcon fontSize='small' />
    </IconButton>
  );

  return (
    <span>
        {
            mode === 'button' && (
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, whiteSpace: 'nowrap' }}>
                    {iconPosition === 'before' && iconButton}
                    {label}
                    {iconPosition === 'after' && iconButton}
                </span>
            )
        }
        {
            mode === 'link' && 
            (
                <Link
                    to={url}
                    target='blank'
                    underline="hover"
                    component={RouterLink}
                    sx={{ fontWeight: 'bold' }}
                >
                    {label}
                </Link>
            )
        }
    </span>
  );
}